import SpecificAssets from './specific-assets';

export default SpecificAssets;
